// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {CSSProperties, useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {use_screen} from '../lib/screen_util';
import {use_translation_v} from '../lib/trans_v';
import styles from './title.module.less';
import cn from 'classnames';
import {Editor} from '../../../shared/editor/editor';

const Confetti_shapes = ()=>{
    const shapes = [
        {path: 'M10 25 Q 20 15, 30 25',
            color: '#A78BFA', className: styles.shape1},
        {path: 'M10 25 Q 20 15, 30 25',
            color: '#60A5FA', className: styles.shape2},
        {path: 'M10 25 Q 20 35, 30 25',
            color: '#FDE047', className: styles.shape3},
        {path: 'M10 25 Q 20 15, 30 25',
            color: '#FDE047', className: styles.shape4},
        {path: 'M10 25 L 40 25',
            color: '#60A5FA', className: styles.shape5, type: 'line'},
        {path: 'M10 25 Q 20 35, 30 25',
            color: '#FDE047', className: styles.shape6},
        {path: 'M10 15 Q 15 25, 20 35',
            color: '#F0ABFC', className: styles.shape7},
        {path: 'M10 25 Q 20 15, 30 25 Q 40 35, 50 25',
            color: '#F0ABFC', className: styles.shape8},
        {path: 'M10 25 Q 20 35, 30 25',
            color: '#60A5FA', className: styles.shape9},
        {path: 'M10 25 L 40 25',
            color: '#FDE047', className: styles.shape10, type: 'line'},
        {path: 'M10 25 Q 20 35, 30 25',
            color: '#FDE047', className: styles.shape11},
        {path: 'M10 25 L 40 25',
            color: '#60A5FA', className: styles.shape12, type: 'line'},
    ];
    return <div className={styles.confetti_wrapper}>
        {shapes.map((shape, idx)=><svg key={idx}
          className={cn(styles.confetti_shape, shape.className)}
          viewBox="0 0 50 50">
            {shape.type === 'line' ?
                <line x1="10" y1="25" x2="40" y2="25"
                  stroke={shape.color} strokeWidth="4" strokeLinecap="round"/>
                :
                <path d={shape.path} stroke={shape.color}
                  strokeWidth="4" fill="none" strokeLinecap="round"/>
            }
        </svg>)}
    </div>;
};

interface i_title {
    title: string;
    subtitle: string;
    is_subtitle_h2?: boolean;
    description?: string;
    description_size?: string;
    max_width?: string;
    max_width_unit?: string;
    gradient?: boolean;
    show_confetti?: boolean;
}

interface i_title_editor_props {
    value: i_title;
    on_change: (new_value: i_title)=>void;
}

export const Title = (props: i_title)=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    const {T} = use_translation_v({no_defaults: true});
    const is_tablet = width < 1440;
    const h_type = props.gradient ? is_tablet ? 'H2' : 'H1'
      : is_tablet ? 'H3' : 'H2';
    const title_width = {
      '--title_width': props?.max_width ?
        `${props?.max_width}${props?.max_width_unit||'px'}` : '100%'
    } as CSSProperties;
    const subtitle_type = props.is_subtitle_h2 ? 'H2' : 'H4';
    const desc_size = props?.description_size ? props.description_size : 'u1';
    return <div className={cn(props.gradient && styles.gradient)}>
      {props.gradient && props.show_confetti && <Confetti_shapes/>}
      <div className={styles.p_title_wrapper}>
        <h1 className={cn(theme[h_type], theme.color_n700, styles.title,
          props.gradient && styles.title_m)} style={title_width}>
          <T>{props.title}</T></h1>
        <p className={cn(theme[subtitle_type], theme.light, theme.color_n700)}>
          <T>{props.subtitle}</T></p>
        {props.description && <p className={cn(theme[desc_size], theme.med,
          styles.description)}>
          <T>{props.description}</T></p>}
      </div>
    </div>;
};

export const Title_editor = (props: i_title_editor_props)=>{
  const {value = {title: '', subtitle: '', description: '',
    description_size: '', gradient: '', max_width: '',
    max_width_unit: '', show_confetti: false, is_subtitle_h2: false},
    on_change} = props;
  type editor_key = keyof i_title;
  type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
  const title_desc = 'Gradient (will enabled full screen'
    +' title and no spacer required above)';
  const editors = [
      ['gradient', title_desc, 'boolean'],
      ['show_confetti', 'Show confetti shapes', 'boolean'],
      ['title', 'Title', 'text'],
      ['max_width', 'Title width', 'text'],
      ['max_width_unit', 'Title width unit(px/rem/em)', 'text'],
      ['subtitle', 'Subtitle', 'text'],
      ['is_subtitle_h2', 'Make H4 subtitle', 'boolean'],
      ['description', 'Description', 'text'],
      ['description_size', 'Description size', 'text'],
  ].map(([key, label, type])=>({key: key as editor_key, label,
      type: type as editor_type}));
  return <Editor
    value={value}
    editors={editors}
    on_change={on_change}
    title="Title"
  />;
};
